<template>
    <Fragment>
        <div class="pageslide">
            <slot />
        </div>
    </Fragment>
</template>

<script>

    import { Fragment } from 'vue-fragment'

    export default {
        name: 'PageSlide',
        components:{
            Fragment
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    @import "../assets/styles/variables";

    .pageslide{
        background-color: transparent;
        position: absolute;
        left:0;
        top:$header-height;
        height: 0;
        width: 100%;
        transition: left ease-in-out 1s;

        /* mobile */
        @media only screen and (max-width : 736px)  {
        }
    }

</style>
